"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports["default"]=isDomElement;function isDomElement(obj){return obj instanceof Element;}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rainbow-modules/hooks/lib/helpers/isDomElement.js
// module id = EpH7
// module chunks = 0